module.exports = __webpack_public_path__ + "static/media/image2.418bd96e.jpg";